import { createContext, type PropsWithChildren, type ReactElement, useContext } from 'react';

// ToDo: Move to a more appropriate location (Replace)
import type { GameConfigurationInterface } from '../components/gameRoot/GameRoot';

const GameConfigContext = createContext<GameConfigurationInterface>({} as GameConfigurationInterface);

interface ConfigProviderProps extends PropsWithChildren {
  value: GameConfigurationInterface;
}

export const GameConfigProvider = ({ value, children }: ConfigProviderProps): ReactElement => {
  return <GameConfigContext.Provider value={value}>{children}</GameConfigContext.Provider>;
};

export const useGameConfig = (): GameConfigurationInterface => useContext(GameConfigContext);
